import { render, staticRenderFns } from "./ClinicFinanceDashboard.vue?vue&type=template&id=d044cdc4"
import script from "./ClinicFinanceDashboard.vue?vue&type=script&lang=js"
export * from "./ClinicFinanceDashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports